import { datadogLogs, StatusType } from '@datadog/browser-logs';
import { useContext } from 'react';

import { LoggerContext } from '../contexts/logger.context';
import { LoggerSettings, UseLogger } from '../interfaces';

export const useLogger = (props?: LoggerSettings): UseLogger => {
  const settings: LoggerSettings = useContext(LoggerContext);
  const { clientToken, service, env, version, applicationId, userId }: LoggerSettings = { ...settings, ...props };
  
  const logger = (logType: string, logDetails: object, logLevel: StatusType = StatusType.error): void => {
    if (clientToken) {
      datadogLogs.logger.log(
        `[Logger:${logType}]`,
        {
          env,
          version,
          service,
          application_id: applicationId,
          host: window.location.host,
          appLogDetails: {
            ...logDetails,
            userId: userId ?? null,
            url: window.location.href,
          },
        },
        logLevel
      );
    }

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log(`🔥[Logger:${logLevel}]🔥: ${logType}`, logDetails);
    }
  };

  return { logger };
};
